import React, { PropsWithChildren, FC } from 'react';
import { Variants } from 'common';

import { selectLocationDetails } from 'infrastructure/redux/slices/bookingWizard.selector';
import { useAppSelector } from 'infrastructure/redux/store/hooks';
import { TextCopyContext } from 'infrastructure/targets/web/contexts/TextCopyContext';
import TextCopy, { resolveDuckpinCopy } from 'infrastructure/targets/web/assets/text/text';
import { isCoralGablesLocation } from 'infrastructure/targets/web/modules/common/helpers';
import { isGenericDuckpin } from 'infrastructure/targets/web/modules/bookingWizard/Steps/SessionLengthStep/helpers';

export const TextCopyContextProvider: FC<PropsWithChildren<object>> = ({ children }) => {
  const variant = (process.env.VITE_VARIANT || Variants.FIVEIRON) as Variants;
  const selectedLocationDetails = useAppSelector(selectLocationDetails);
  const generic = isGenericDuckpin();
  const coralGables = isCoralGablesLocation(selectedLocationDetails);
  const provider = {
    getTextCopy: (code: string) =>
      variant === Variants.DUCKPIN
        ? resolveDuckpinCopy(code, generic, coralGables)
        : TextCopy[variant][code],
  };

  return <TextCopyContext.Provider value={provider}>{children}</TextCopyContext.Provider>;
};
